/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { scroller } from "react-scroll";

const Infos = () => {
  const abouts = [
    { text: "About TrueApex", href: "" },
    {
      text: "View Whitepaper",
      href: "https://trueapexfinances-organization.gitbook.io/product-docs/",
    },
    { text: "FAQ", href: "" },
    { text: "Terms & Conditions", href: "" },
    { text: "Privacy Policy", href: "" },
  ];
  const menus = ["Home", "Mint NFT", "Inventory"];
  return (
    <div className="w-full xs:h-[609px] h-fit relative p-[104px_12px_80px_12px] bg-primary text-white">
      <StyledBox className="absolute left-0 top-0 w-full h-full" />
      <div className="relative z-10 w-full max-w-[1362px]  mx-auto">
        <img
          src={"/images/footer/logo.png"}
          alt={""}
          className="md:xs:w-[455px] xs:w-[350px] w-[280px]"
        />
        <div className="flex w-full justify-between xs:mt-20 mt-14 xs:flex-row flex-col">
          <div>
            <div className="md:text-xl text-sm font-semibold">
              <div className="text-green  mb-3">Contact Us</div>
              <a href={"malto:inquiries@trueapex.finance"} className="font-medium underline">
                inquiries@trueapex.finance
              </a>
            </div>
            <div className="md:text-xl text-sm font-semibold mt-10">
              <div className="text-green  mb-3 md:max-w-[228px] max-w-[180px]">
                Media & Partnership Enquiries
              </div>
              <a href={"malto:submissions@trueapex.finance"} className="font-medium underline">
                submissions@trueapex.finance
              </a>
            </div>
          </div>
          <div className="flex flex-1 lg:sm:max-w-[500px] sm:max-w-[400px] max-w-fit xs:mt-0 mt-10 w-full">
            <div className="font-medium flex flex-col md:xs:mr-20 xs:mr-10 mr-0">
              <div className="text-green md:text-xl text-base font-semibold">About</div>
              {abouts.map((data, i) => {
                return (
                  <Link
                    // href={data.href}
                    rel="noreferrer"
                    className={`mt-4 hover:opacity-70 transition-all md:text-base text-sm`}
                    key={i}
                    to={i === 0 ? "/home" : i === 1 ? data.href : ""}
                    target={i === 1 ? "_blank" : ""}
                    onClick={() => {
                      if (i === 0)
                        setTimeout(() => {
                          scroller.scrollTo("About", {
                            duration: 1000,
                            delay: 0,
                            smooth: true,
                          });
                        }, 10);
                    }}
                  >
                    {data.text}
                  </Link>
                );
              })}
            </div>
            <div className="flex flex-col text-xl xs:ml-0 ml-16">
              <div className="text-green font-semibold md:text-xl text-base">Browse</div>
              {menus.map((data, i) => {
                return (
                  <Link
                    to={`/${data.replace(" ", "").toLowerCase()}`}
                    className="mt-3.5 hover:opacity-70 transition-all md:text-base text-sm"
                    key={i}
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  >
                    {data}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StyledBox = styled.div`
  background: url("/images/footer/info.png");
`;

export default Infos;
